import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { environment } from '@env';

async function loadEnvironment(): Promise<void> {
  try {
    const response = await fetch('/env');
    const env = await response.json();
    environment.support.mail.to = env.support_mail_to;
    environment.support.mail.cc = env.support_mail_cc;
  } catch (err) {
    console.error('Failed to load environment variables', err);
  }
}

loadEnvironment().then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
